import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({
  form: {
    width: "auto",
    marginTop: "0px",
    marginRight: "15px",
    marginLeft: "15px",

  },
  formControl: {
    padding: "8px",
    maxHeight: "35px",
    maxWidth: "331px",

  },
  menuItem: {
    "&:hover": {
      borderLeft: "4px solid #098B8B",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  dropdown: {
    backgroundColor: "#FFFFFF",
    boxSizing: "border-box",
    borderRadius: "8px",
    height: "35px",
    fontSize: "14px",
    [`& fieldset`]: {
      borderRadius: 8,
      fontSize: 14,
    },
  },
  notes: {
    backgroundColor: "#FFFFFF",
    boxSizing: "border-box",
    borderRadius: "8px",
    fontSize: "14px",
    [`& fieldset`]: {
      borderRadius: 8,
      fontSize: 14,
    },
  },
  field: {
    borderRadius: "8px",
    height: "35px",

  },
}));

export const styleSearch = makeStyles((theme) => ({
  table: {
    minWidth: 500,
  },
  buttonSearch: {
    color: "#ffffff",
    background: "#7EBDCE",
    "&:hover": { color: "white", background: "#099F9F" },
  },
  buttonClear: {
    color: "#666666",
    border: "solid 1px",
    background: "#ffffff",
    "&:hover": { color: "#099F9F", background: "#ffffff" },
  },
  form: {
    paddingTop: "0px",
    padding: "12px",

  },
  card: {
    marginTop: "0px",
    marginLeft: "8px",
    border: "0",
    boxShadow: "none",
    //maxWidth: "699.5px",
    maxWidth: "100%",
    maxHeight: "auto",
    backgroundColor: "#E0F2F7",
  },
  formControl: {
    padding: "8px",
    maxHeight: "48px",
    maxWidth: "331px",
  },
  select: {
    paddingTop: "10.5px",
    paddingBottom: "10.5px",
  },
  menuItem: {
    "&:hover": {
      borderLeft: "4px solid #098B8B",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  whiteBackGround: {
    backgroundColor: "#FFFFFF"
  },
}));

export const searchStyles = makeStyles ((theme) => ({
  root: {
    width: "92%",
    marginTop: "20px",
    //marginLeft: "10px",
  },
  column: {
    flexBasis: "39.6%",
    marginRight: 10,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
    wordBreak: 'normal',
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
    wordBreak: 'normal'
  },
  checked: {
    marginRight: 20
  }
}));

export const useStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  checkedIcon: {
    backgroundColor: '#098B8B',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#7EBDCE',
    },
  },
  menuItem: {
    "&:hover": {
      borderLeft: "4px solid #098B8B",
    },
},

});
